// 导入自己需要的组件
import Vue from 'vue';
import { Dialog, Message, Loading, Notification, MessageBox, Carousel, CarouselItem } from 'element-ui'

const element = {
  install (Vue) {
    Vue.use(Dialog),
    Vue.use(Carousel),
    Vue.use(CarouselItem)
  }
}

Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading;
Vue.prototype.$notify = Notification;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm


export default element